// Copyright (c) 2016 Deere & Company

import NewTransfer from './components/new-transfer';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.createTransfer,
    customer: state.customer.details,
    isCkcCustomerFailed: state.customerFailed.ckcCustomerFailed,
    measurementReadings: state.latestPerUnitMeasurements
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(NewTransfer);



// WEBPACK FOOTER //
// ./src/product/new-transfer/state-connector.js